// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import CheckboxFilterControlled from '../../../../shared/components/facets/checkbox-filter/controlled';
import FacetFooter from '../../../../shared/components/facets/facet-footer';
import Facets from '../../state/facets';
import FacetsDateRangePickerControlled from '../../../../shared/components/facets/date-range-picker/controlled';
import ProductHierarchyFacet from './product-hierarchy';
import ReimbursementFacet from './reimbursement-facet';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';

function handleClaimTypeToggle() {

    this.actions.toggleClaimTypes(this.facets.allowedClaimTypes);

}

class AuditClaimFacets extends Component {

    state = {
        claimTypeExpanded: false,
        dateIssuedExpanded: false,
        productHierarchyExpanded: false,
        reimbursementExpanded: false
    };

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.productHierarchyExpanded || this.state.claimTypeExpanded || this.state.reimbursementExpanded || this.state.dateIssuedExpanded;

    render() {

        return (
            <section className='facets'>
                <ProductHierarchyFacet
                    allowedProductHierarchy={this.props.facets.allowedProductHierarchy}
                    isExpanded={this.state.productHierarchyExpanded}
                    onClick={this.onAccordionToggle.bind(this, 'productHierarchyExpanded')}
                    onSelectProductCode={this.props.actions.updateSelectedProductCode}
                    selectedProductCode={this.props.facets.selectedProductCode}

                />
                <CheckboxFilterControlled
                    displayKey='value'
                    initialState={createHashMap(this.props.facets.selectedClaimTypes, 'key')}
                    isExpanded={this.state.claimTypeExpanded}
                    list={addCollectionLabels(this.props.facets.allowedClaimTypes, 'value')}
                    minNumberOfItems={4}
                    onChange={this.props.actions.updateClaimTypeSelection}
                    onClick={this.onAccordionToggle.bind(this, 'claimTypeExpanded')}
                    onToggleAll={this.props::handleClaimTypeToggle}
                    title='CLAIM_TYPES'
                    valueKey='key'
                />
                <ReimbursementFacet
                    isExpanded={this.state.reimbursementExpanded}
                    onClick={this.onAccordionToggle.bind(this, 'reimbursementExpanded')}
                    onReimbursedAmountChange={this.props.actions.updateReimbursementRangeDollars}
                    onReimbursedPercentChange={this.props.actions.updateReimbursementRangePercent}
                    onShowReimbursedAmount={this.props.actions.showReimbursedAmount}
                    onShowReimbursedPercent={this.props.actions.showReimbursedPercent}
                    reimbursedAmount={this.props.facets.reimbursedAmount}
                    reimbursedPercent={this.props.facets.reimbursedPercentage}
                    showReimbursedAmount={this.props.facets.showReimbursedAmount}
                />
                <FacetsDateRangePickerControlled
                    dateFormat=''
                    dateRange={this.props.facets.dateIssued}
                    isExpanded={this.state.dateIssuedExpanded}
                    onChange={this.props.actions.updateDateIssued}
                    onClick={this.onAccordionToggle.bind(this, 'dateIssuedExpanded')}
                    title='DATE_ISSUED'
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={false}
                        onApply={this.props.onApplyFilters}
                        onReset={this.props.actions.resetFacets}
                    /> : null}
            </section>
        );

    }

}

AuditClaimFacets.displayName = 'AuditClaimFacets';
AuditClaimFacets.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.instanceOf(Facets).isRequired,
    onApplyFilters: PropTypes.func.isRequired
};

export default AuditClaimFacets;



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/components/facets/audit-claims-facets.js